import apiClient from '@/api/client'

export interface ClassResponse {
  id: string
  name: string
  class_id?: string
  notes?: string | null
  location?: string | null
  address?: string | null
  weekly_time_desc?: string | null
  weekly_time_description?: string | null
  start_date?: string | null
  teacher_names?: string[]
  teacher_ids?: string[]
  last_edited_by_user_id?: string | null
  last_edited_at?: string | null
  last_edited_by_name?: string | null
}

export interface CreateClassPayload {
  name: string
  // (location / weekly_time_desc are legacy aliases the API ignores — use address / weekly_time_description)
  notes?: string | null
  location?: string | null
  address?: string | null
  weekly_time_desc?: string | null
  weekly_time_description?: string | null
  start_date?: string | null
  teacher_ids?: string[]  // Admins only: replaces the class's teacher assignments
}

export interface ClassExportResponse {
  class_id: string
  name: string
  notes?: string | null
  address?: string | null
  weekly_time_description?: string | null
  start_date?: string | null
  events: Array<{
    topic: string
    notes?: string | null
    event_date?: string | null
    is_recurring?: boolean
    recurrence_rule?: string | null
  }>
}

export const classesApi = {
  async list(): Promise<ClassResponse[]> {
    const { data } = await apiClient.get('/api/v1/classes')
    return data
  },
  async create(payload: CreateClassPayload): Promise<ClassResponse> {
    const { data } = await apiClient.post('/api/v1/classes', payload)
    return data
  },
  async update(id: string, payload: Partial<CreateClassPayload>): Promise<ClassResponse> {
    const { data } = await apiClient.put(`/api/v1/classes/${id}`, payload)
    return data
  },
  async remove(id: string): Promise<{ ok: true }> {
    const { data } = await apiClient.delete(`/api/v1/classes/${id}`)
    return data
  },
  async export(classId: string): Promise<ClassExportResponse> {
    const { data } = await apiClient.get<ClassExportResponse>(`/api/v1/classes/${classId}/export`)
    return data
  },
  async import(classJson: ClassExportResponse, targetStartDate: string): Promise<ClassResponse> {
    const { data } = await apiClient.post<ClassResponse>(`/api/v1/classes/import?target_start_date=${encodeURIComponent(targetStartDate)}`, {
      class_json: classJson,
    })
    return data
  },
}



